import { NextRouter } from 'next/router';

export function isZapTemplate(next: string | null) {
  return Boolean(
    next &&
      (next.includes('/app/editor/template/') || next.includes('template='))
  );
}

type ID = string | number;

export function getZapTemplateId(router: NextRouter): ID | null {
  if (router.query.template) {
    return router.query.template as ID;
  }

  if (router.query.szid) {
    return router.query.szid as ID;
  }

  const next = (router.query.next || '') as string | null;

  if (isZapTemplate(next)) {
    const templateId = next?.split('/').pop() || '';
    return templateId.split('?')[0] as ID;
  }

  if (next?.includes('?')) {
    // @ts-ignore
    const params = Object.fromEntries(new URLSearchParams(next.split('?')[1]));

    if (params.template) {
      return params.template as ID;
    }
  }

  return null;
}
